import { activitiesSlice, activityApi } from '@store';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useNotifications = () => {
  const dispatch = useDispatch();

  const { jwtAuthenticationToken } = useSelector((state) => state.authSlice);
  const { notifications } = useSelector((state) => state.activitiesSlice);

  const { data, refetch } = activityApi.useGetNotificationsQuery(undefined, {
    refetchOnMountOrArgChange: true,
    skip: !jwtAuthenticationToken,
  });

  useEffect(() => {
    dispatch(activitiesSlice.actions.setNotifications(data?.data));
  }, [data]);

  return {
    notifications,
    refetchNotifications: jwtAuthenticationToken ? refetch : () => {},
  };
};
